export default {"src":"/_next/static/media/pcce.b6601ddc.svg","height":10,"width":31,"blurWidth":0,"blurHeight":0};